import React from 'react';
interface BeheerSectionProps {
  id: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}
export function BeheerSection({
  id,
  title,
  description,
  action,
  className = '',
  children
}: BeheerSectionProps) {
  return <section aria-labelledby={`${id}-title`} className={className} data-id="element-44" data-mp="3viv1vp0l8k73">
      <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-45" data-mp="3vlqzfc8ix6v0">
        <div data-id="element-46" data-mp="37uc0zujvb9p1">
          <h2 id={`${id}-title`} className="text-[20px] font-semibold text-ink" data-id="element-47" data-mp="37vwo4z3urqcv">
            {title}
          </h2>
          {description && <p className="mt-1 text-[14px] text-ink-muted" data-id="element-48" data-mp="3hrqatbbad08d">{description}</p>}
        </div>
        {action}
      </div>
      <div className="mt-5" data-id="element-49" data-mp="3csnce9pt9s9d">{children}</div>
    </section>;
}